import { TenantsApi } from "@/services/tenants-service"
import { useSystemFeedback } from "@/stores/systemFeedback"
import { useAuth } from "@/stores/auth"
import { useContents } from "@/stores/contents"
import router from "@/router"
import { defineStore } from "pinia"
import type { SetTenant, TenantUser } from "@/types/tenants"
import type { ApiError } from "@/types/api"

export const useTenants = defineStore("tenants", {
  state: () => {
    return {
      userTenants: [] as TenantUser[],
      api: new TenantsApi(),
      useAuthStore: useAuth()
    }
  },

  getters: {
    loggedUserUsername: state => state.useAuthStore.loggedUser.username
  },

  actions: {
    async getUserTenants() {
      try {
        const response = await this.api.getUserTenants(this.loggedUserUsername)
        this.userTenants = response.data.companies
        return response
      } catch (error) {
        this.handleErrors(error as ApiError)
      }
    },

    async setTenant(data: SetTenant) {
      const tenantIsAlreadySelected = this.userTenants.find(
        tenant => tenant.company_id === data.company_id
      )?.default
      if (
        tenantIsAlreadySelected &&
        router.currentRoute.value.name !== "Login"
      ) {
        return
      }

      try {
        const companyId = data.company_id
        const response = await this.api.setTenant(companyId)
        this.useAuthStore.setAccessToken(
          response.data.access_token,
          response.data.refresh_token
        )
        localStorage.removeItem("token")
        if (router.currentRoute.value.name === "Login") {
          const contentsStore = useContents()
          await contentsStore.getHighlightContent()
          return response
        } else {
          window.location.reload()
          localStorage.setItem("tenant-changed", "true")
        }
      } catch (error) {
        this.handleErrors(error as ApiError)
      }
    },

    handleErrors(error: ApiError) {
      const errorMessage = error?.response
        ? `backend.${error.response.data.detail}`
        : "requestError.default"
      useSystemFeedback().setFeedback({ type: "danger", text: errorMessage })
    }
  }
})
